var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gl-display-flex gl-align-items-top gl-font-monospace gl-font-sm gl-word-break-all",class:[_vm.padding, _vm.borderClass]},[(_vm.icon)?_c('div',{staticClass:"gl-w-5 gl-mr-4"},[_c('gl-icon',{attrs:{"name":_vm.icon}})],1):_vm._e(),_vm._v(" "),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }